import React from "react";
import { Button, Menu, MenuItem, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface ActionItem {
  title: string;
  onClick: () => void;
  color?: "inherit" | "primary" | "secondary" | "error";
}

interface ActionMenuProps {
  actions: ActionItem[];
}

const ActionMenu: React.FC<ActionMenuProps> = ({ actions }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Actions">
        <Button variant="contained" onClick={handleClick} endIcon={<MoreVertIcon />} size="small">
          Actions
        </Button>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions.map(action => (
          <MenuItem
            key={action.title}
            onClick={() => {
              handleClose();
              action.onClick();
            }}
            style={action.color === "error" ? { color: "red" } : undefined}
          >
            {action.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
